import { tbColors, tbPalette } from 'styles/colors';

const getSelectMenuTopSearch = () => ({
  styleOverrides: {
    searchInput: {
      '& > div:first-of-type': {
        border: `0.5px solid ${tbColors.all.ash[900]} `,
        backgroundColor: tbPalette.background.bright,
        overflow: 'hidden',
        display: 'flex',
        fontSize: '14px',
      },
    },
  },
});

export default getSelectMenuTopSearch;
